import Rows from "./Row/Row"
import Columns from "./Column"

export const Row = Rows
export const Column = Columns
